import AuthService from './AuthService';

class ClientProfileService {
    constructor() {
        const rawBaseUrl = process.env.REACT_APP_CHATBOT_API_URL || process.env.CHATBOT_API_URL || '';
        this.apiBaseUrl = rawBaseUrl.replace(/\/+$/, '');
    }

    getAuthHeaders(extraHeaders) {
        const token = AuthService.getAccessToken();
        const authHeader = token ? { Authorization: `Bearer ${token}` } : {};
        return {
            ...authHeader,
            ...(extraHeaders || {}),
        };
    }

    async getClientProfile(clientId) {
        if (!clientId) throw new Error('clientId is required');
        const url = `${this.apiBaseUrl}/admin/clients/${encodeURIComponent(clientId)}/profile`;
        const response = await fetch(url, {
            method: 'GET',
            headers: this.getAuthHeaders(),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    }

    async upsertClientProfile(clientId, payload) {
        if (!clientId) throw new Error('clientId is required');
        const url = `${this.apiBaseUrl}/admin/clients/${encodeURIComponent(clientId)}/profile`;
        const response = await fetch(url, {
            method: 'PUT',
            headers: this.getAuthHeaders({ 'Content-Type': 'application/json' }),
            body: JSON.stringify(payload || {}),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    }
}

const clientProfileService = new ClientProfileService();
export { ClientProfileService };
export default clientProfileService;
